import React from 'react';
import { Element } from 'react-scroll';

const Feature0 = () => {
  return (
    <Element name="component2" className="component">
      <div className="grid grid-cols-1 sm:grid-cols-12 lg:gap-4 sm:gap-0">
        <div className="lg:col-span-1 sm:col-span-12 p-2 sm:justify-start sm:items-start lg:items-center lg:justify-center" />
  
        {/* Main Content Section */}
        <div className="lg:col-span-6 sm:col-span-12 p-2 flex items-center justify-center ">
          <img 
            src="https://images.unsplash.com/photo-1524492412937-b28074a5d7da?q=80&w=2071&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D" 
            alt="Travel"
          />
        </div>
        
        <div className="lg:col-span-4 sm:col-span-12 flex flex-col lg:pl-10 sm:p-1 ">
          <div className="lg:text-4_5xl sm:text-3xl text-custom-blue font-sans sm:flex sm:justify-center">
            <div className='sm:w-3/4 lg:w-full'>
            In your next trip, take a hop.
            </div>
          </div>
          <div className="text-1_5xl text-custom-blue pt-7 font-sans sm:flex sm:justify-center">
            <div className='sm:w-3/4 lg:w-full'>
            Find the best of ideas, plans, reviews and more for your next trip.
            Once a hopper, never waste a single second comparing lists & itineraries to find out what suits you the most.
            </div>
          </div>
          <div className="text-1_5xl text-custom-blue pt-7 italic font-sans sm:flex sm:justify-center">
            <div className='sm:w-3/4 lg:w-full'>
              Instead let hop do all of that for you, so that you can enjoy the view of Taj Mahal.
            </div>
          </div>
        </div>
  
        <div className="lg:col-span-1 sm:col-span-12 p-2 flex items-center justify-center " />
      </div>
    </Element>
  );
  
  
};

export default Feature0;
